import { render, staticRenderFns } from "./ArticleListIndex.vue?vue&type=template&id=c6b217ca&scoped=true"
import script from "./ArticleListIndex.vue?vue&type=script&lang=js"
export * from "./ArticleListIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b217ca",
  null
  
)

export default component.exports